import React from 'react'
import BlurBlueDecorationLarge from '../decorations/BlurBlueDecorationLarge';
import BlurOrangeDecorationSmall from '../decorations/BlurOrangeDecorationSmall';

const FooterDecoration = () => {
    return (
        <>
            <div className='position-absolute d-none d-lg-block' style={{ top: '-10%', right: '-5%' }}><BlurBlueDecorationLarge /></div>
            <div className='position-absolute ' style={{ bottom: '0%', left: '-3%' }}><BlurOrangeDecorationSmall /></div>
        </>
    )
}

export default FooterDecoration